<template>
    <div class="mt-4">
        <div>
            <div>
                <!-- <label
                    class="block-title ps-0 mb-4 ppv2-text-black mt-4 pb-1"
                    style="font-size: clamp(12px, 0.729545vw, 16px) !important; border-bottom: 1px solid rgb(98, 194, 246); padding-bottom: 15px"
                >
                    Options
                </label> -->

                <div v-if="sendInvoice" id="container_company" class="form-group mb-4 mx-2">
                    <label class="form-label" for="company_name">{{ $t('checkout.sale.add_company') }}</label>
                    <input
                        class="form-control"
                        style="background: transparent"
                        type="text"
                        name="company_name"
                        id="company_name"
                        v-model="company_name"
                    />
                    <div class="d-flex gap-2 w-100 mt-4">
                        <div class="w-100">
                            <label class="form-label" for="company_address">{{ $t('checkout.sale.address') }}</label>
                            <input
                                style="background: transparent"
                                class="form-control"
                                type="text"
                                name="company_address"
                                id="company_address"
                                ref="company_address"
                                v-model="company_address.address"
                            />
                        </div>
                        <div class="w-100">
                            <label class="form-label" for="company_cp">{{ $t('checkout.sale.postal_code') }}</label>
                            <input
                                style="background: transparent"
                                class="form-control"
                                type="text"
                                name="company_cp"
                                id="company_cp"
                                ref="company_cp"
                                v-model="company_address.cp"
                            />
                        </div>
                        <div class="w-100">
                            <label class="form-label" for="company_country">{{ $t('checkout.sale.country') }}</label>
                            <input
                                style="background: transparent"
                                class="form-control"
                                type="text"
                                name="company_country"
                                id="company_country"
                                ref="company_country"
                                v-model="company_address.country"
                            />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <input type="hidden" name="company_name" :value="company_name" />
                    <input type="hidden" name="company_address" :value="company_address.address" />
                    <input type="hidden" name="company_cp" :value="company_address.cp" />
                    <input type="hidden" name="company_country" :value="company_address.country" />
                </div>

                <div v-if="sendMail" class="mb-3">
                    <label class="ppv2-text-black mb-3 fs-6 fw-medium">{{ $t('checkout.thanks_mail.title') }}</label>

                    <div class="form-check ps-0 d-flex align-items-center">
                        <input
                            id="notice"
                            class="form-check-input"
                            type="radio"
                            @change="
                                (event) => {
                                    parameterThanks.notice = event.target.checked
                                }
                            "
                            style="height: 18px"
                        />
                        <label for="notice" class="form-label ppv2-text-black mb-0 ps-2">{{
                            $t('checkout.thanks_mail.notice_links')
                        }}</label>
                    </div>
                </div>
                <!-- <div class="d-flex justify-content-between align-items-center flex-shrink-0 flex-wrap">
                    <div class="form-switch p-0 mb-2">
                        <input type="hidden" name="parameterThanksMail" :value="JSON.stringify(parameterThanks)" />
                        <input v-if="sendMail" type="hidden" id="send_mail" name="send_mail" :value="sendMail" />
                        <button
                            type="button"
                            role="button"
                            class="btn btn-dark btn-dark-index px-3"
                            :class="sendMail ? ' text-white' : 'text-white'"
                            @click="
                                () => {
                                    sendMail = !sendMail
                                    if (!sendMail) {
                                        parameterThanks = {
                                            rebooking: null,
                                            notice: null,
                                        }
                                    }
                                }
                            "
                            ref="sendMailBtn"
                        >
                            <i
                                style="margin-right: 9px"
                                class="fa fa-xs fa-fw fa-check"
                                :class="sendMail ? 'd-inline-block' : 'd-none'"
                                ref="sendMailIcon"
                            ></i
                            >Mail de remerciement
                        </button>
                    </div>
                    <div class="form-switch p-0 mb-2">
                        <input v-if="sendInvoice" type="hidden" id="send_invoice" name="send_invoice" :value="sendInvoice" />
                        <button
                            type="button"
                            role="button"
                            class="btn btn-dark btn-dark-index px-3"
                            :class="sendInvoice ? ' text-white' : ''"
                            @click="
                                () => {
                                    sendInvoice = !sendInvoice
                                    if (!sendInvoice) {
                                        company_name = null
                                        company_address = {
                                            address: null,
                                            cp: null,
                                            country: null,
                                        }
                                    }
                                }
                            "
                            ref="sendInvoiceBtn"
                        >
                            <i
                                style="margin-right: 9px"
                                class="fa fa-xs fa-fw fa-check pe-2"
                                :class="sendInvoice ? 'd-inline-block' : 'd-none'"
                                ref="sendInvoiceIcon"
                            ></i
                            >Facture
                        </button>
                    </div>
                </div> -->
            </div>
            <div class="alert alert-warning alert-dismissible mb-4" role="alert" v-if="c_remainPrice < 0">
                <p class="mb-0">{{ $t('checkout.payment.excess_amount_warning') }}</p>
            </div>

            <div class="d-flex justify-content-center align-items-center w-100">
                <input type="hidden" id="order_id" name="order_id" :value="orderId" />
                <input type="hidden" id="wallet_transaction" name="wallet_transaction" :value="walletTransaction" />
                <input type="hidden" id="close_sale" name="close_sale" :value="closeSale" />
                <input type="hidden" name="parameterThanksMail" :value="JSON.stringify(parameterThanks)" />
                <input v-if="sendMail" type="hidden" id="send_mail" name="send_mail" :value="sendMail" />
                <div class="d-flex justify-content-between align-items-center w-100">
                    <button
                        id="cashIn"
                        class="btn text-white fs-xs fw-medium px-4 rounded-8 h-40 fw-medium fs-xs"
                        style="width: 49%"
                        :class="[c_remainPrice > 0 ? 'btn-warning' : c_remainPrice < 0 ? 'btn-danger' : 'btn-dark']"
                        @click="submitForm()"
                        type="button"
                        :disabled="!isCartItemsLoaded || !canSubmit"
                    >
                        {{ $t('checkout.payment.cash_in') }}
                    </button>
                    <button
                        type="button"
                        role="button"
                        class="btn px-4 rounded-8 h-40 b-blue fw-medium fs-xs ppv2-text-black"
                        style="width: 49%"
                        :disabled="c_remainPrice != 0 || !canSubmit"
                        @click="payAndClose()"
                        ref="closeSaleBtn"
                    >
                        <i
                            style="margin-right: 9px"
                            class="fa fa-xs fa-fw fa-check"
                            :class="closeSale ? 'd-inline-block' : 'd-none'"
                            ref="closeSaleIcon"
                        ></i>
                        {{ $t('checkout.payment.cash_in_and_close') }}
                    </button>
                </div>
            </div>
        </div>
        <div :class="Object.values(staffModalData).every((s) => s !== null) ? 'd-block' : 'd-none'">
            <staff-modal
                v-if="staffModalData.cartRowId && staffModalData.adviserId && staffModalData.sellerId"
                :cartRowId="staffModalData.cartRowId"
                :adviserId="staffModalData.adviserId"
                :sellerId="staffModalData.sellerId"
                @hide-staff-modal="hideStaffModal"
            ></staff-modal>
        </div>
        <close-sale-modal
            v-if="showModalCloseSale"
            :closeSaleModal="showModalCloseSale"
            :companyName="company_name"
            :companyAddress="company_address"
            :parameterThanks="parameterThanks"
            :sendInvoice="sendInvoice"
            :sendMail="sendMail"
            @close-sale="hideCloseSaleModal"
            @close-sale-modal="closeSaleModal"
        ></close-sale-modal>
    </div>
</template>

<script>
import moment from 'moment'
import { sync, get } from 'vuex-pathify'
import StaffModal from './StaffModal.vue'
import axios from 'axios'
import CloseSaleModal from './CloseSaleModal.vue'

export default {
    components: { StaffModal, CloseSaleModal },
    props: ['promoCode', 'orderId', 'walletTransaction', 'orderObj', 'isCartItemsLoaded', 'canCreateOrder', 'canModifyOrder'],
    data: () => ({
        closeSale: false,
        showModalCloseSale: false,
        staffModalData: { cartRowId: null, adviserId: null, sellerId: null },
        parameterThanks: {
            rebooking: false,
            notice: false,
        },
        company_name: null,
        company_address: {
            address: null,
            cp: null,
            country: null,
        },
        sendInvoice: false,
        sendMail: false,
    }),
    created() {
        this.sendInvoice = this.orderObj && this.orderObj.send_invoice
        this.sendMail = false
        this.company_name = this.orderObj && this.orderObj.company_name
        if (this.orderObj && this.orderObj.company_address) {
            const full_address = this.orderObj.company_address.split('_')
            this.company_address.address = full_address[0]
            this.company_address.cp = full_address[1]
            this.company_address.country = full_address[2]
        }
    },
    computed: {
        canSubmit() {
            const hasCreate = this.canCreateOrder === true || this.canCreateOrder === 'true'
            const hasModify = this.canModifyOrder === true || this.canModifyOrder === 'true'
            if (this.orderId && parseInt(this.orderId) !== 0) {
                return hasModify
            }
            return hasCreate
        },
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_payments: 'payments',
            c_customer: 'customer',
            c_establishment: 'establishment',
            c_prepaidPrestations: 'prepaidPrestations',
            c_promoCodes: 'promoCodes',
            c_customDiscount: 'customDiscount',
            c_order: 'order',
            c_remainBeforeGlobalPromoCode: 'remainBeforeGlobalPromoCode',
            c_remainAfterGlobalPromoCode: 'remainAfterGlobalPromoCode',
            c_promoCodeNoCompleteUsed: 'promoCodeNoCompleteUsed',
            c_voucherUsed: 'voucherUsed',
        }),
        ...sync('overlay@data', {
            c_cartItems: 'cartItems',
            c_promoCodes: 'promoCodes',
        }),
        maxFidelityPoint() {
            return this.c_customer.customer.loyalty_points
        },
    },
    methods: {
        console() {
            return console
        },
        getVoucherCode(id) {
            return axios.get(`/back-office/caisse/getVoucherCode/${id}`).then((res) => res.data)
        },
        stringify(val) {
            return JSON.stringify(val)
        },
        parseDate(date, format) {
            return moment(date).locale(this.$i18n.locale).format(format)
        },
        getValueOfDate(date) {
            return moment(date).valueOf()
        },

        submitForm() {
            if (this.c_remainPrice == 0 && this.closeSale == false) {
                //this.closeSale = true
                this.showModalCloseSale = true
            } else {
                this.$emit('submit-form')
            }
        },
        payAndClose() {
            this.closeSale = true
            setTimeout(() => {
                this.$emit('submit-form')
            }, 300)
        },
        openStaffModal(cartRowId, adviserId, sellerId) {
            this.staffModalData = {
                cartRowId: cartRowId,
                adviserId: adviserId,
                sellerId: sellerId,
            }
        },
        hideStaffModal() {
            Object.keys(this.staffModalData).forEach((key) => {
                this.staffModalData[key] = null
            })
        },
        hideCloseSaleModal(data) {
            this.closeSale = data.close_sale
            this.company_name = data.company_name
            this.company_address = data.company_address
            this.parameterThanks.rebooking = data.rebooking
            this.parameterThanks.notice = data.notice
            this.showModalCloseSale = false
            this.sendMail = data.send_mail
            this.sendInvoice = data.send_invoice

            setTimeout(() => {
                this.$emit('submit-form')
            }, 300)
        },
        closeSaleModal() {
            this.closeSale = false
            this.showModalCloseSale = false
        },
    },
    watch: {
        c_remainPrice(val) {
            if (this.closeSale && val !== '0.00') {
                this.closeSale = false
            }
        },
    },
}
</script>

<style scoped>
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
.theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: transparent !important;
}
</style>
<style scoped>
#promo-code-select {
    margin: 15px 0px;
    width: 100%;
}
select#promo-code-select {
    height: 40px;
    font-size: clamp(12px, 0.729545vw, 16px);
    padding-top: 9px;
    border-radius: 7px;
}
.btn-dark-appli {
    font-size: 16px !important;
    padding-left: 26px !important;
    padding-right: 26px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
}
.btn-green-appli {
    color: #fff !important;
    background: #46d5b3;
    font-size: 16px !important;
    padding-left: 26px !important;
    padding-right: 26px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
    border: solid 1px #46d5b3;
}
.form-control,
.form-select {
    border-radius: 8px;
    height: 40px;
    /*padding-top: 8px;*/
    font-size: clamp(12px, 0.729545vw, 16px);
}
.rest-du {
    background: #7d2dbd;
    border-radius: 4px;
    padding: 5px 12px;
    height: 32px !important;
}
.box-amount {
    font-weight: 400px;
    font-size: 12px;
    padding: 2px 17px;
    border-radius: 4px;
    background: #46d5b3;
    color: white;
}
.some-amount {
    border: solid 1px #7b8289;
    border-radius: 8px;
    padding: 4px 8px;
    width: 80%;
}
.title-some-am {
    border-bottom: solid 1px #7d2dbd;
}
#toggleButton {
    cursor: pointer;
    transition: transform 0.3s;
}
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
.b-blue {
    border: 1px solid #334155;
}
</style>
